<section [hidden]="!loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>handshake</mat-icon> Partner Administration
      <br /><br />
      <button mat-raised-button color="primary" title="Add Partner" (click)="openEditPartnerDialog(null)">
        <mat-icon>add</mat-icon> Add Partner
      </button>
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">&nbsp;</div>
</div>

<section [hidden]="loading">
  <mat-card>

    <mat-card-content>
      <div fxLayout="column" class="matero-col" *ngIf="!loading">
        <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto">
          <strong class="noMarginHeader">Partners ({{ resultSize }})</strong>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <mat-form-field style="width: 200px">
            <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
          </mat-form-field>
          <a (click)="load()"><mat-icon>refresh</mat-icon> </a>
        </div>

        <div fxLayout="row" *ngIf="!loading">
          <span>&nbsp;</span>
        </div>

        <section *ngIf="loading">
          <h2>Loading...</h2>
          <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading content">
          </mat-progress-bar>
        </section>
        <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto">
          <mat-row>Results ({{ resultSize }})</mat-row>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

          <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Partner Access Id</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <a (click)="openEditPartnerDialog(result)" *ngIf="result.id != null && result.id > 0" title="Edit Partner Access {{ result.id }}">{{ result.id }}</a>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="partnerName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Partner Name</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <span>{{ result.partnerName }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="accessStartDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Access Start Date</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <span>{{ result.accessStartDate }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="accessEndDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Access End Date</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <span>{{ result.accessEndDate }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="accessType">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Access Type</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{ result.accessType }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="requiresPassKey">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Requires Pass Key</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <span *ngIf="result.requiresPassKey">Yes</span>
              <span *ngIf="!result.requiresPassKey">No</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="requiresDisclaimerApproval">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Requires Disclaimer Approval</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <span *ngIf="result.requiresDisclaimerApproval">Yes</span>
              <span *ngIf="!result.requiresDisclaimerApproval">No</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <a href="javascript:void(0)" *ngIf="result.id > 0" (click)="removePartnerAccess(result.id)" title="Remove Partner Access id {{ result.id }}">
                <mat-icon>delete</mat-icon>
              </a>
              &nbsp;&nbsp;
              <a href="javascript:void(0)" *ngIf="
                  result.id > 0 &&
                  result.accessUriGuid != null &&
                  result.accessUriGuid.length > 0
                " (click)="clipboardCopyPartnerAccess(result.accessUriGuid)" title="Clipboard Copy Partner Access URL for {{
                  result.partnerName
                }}">
                <mat-icon>content_copy</mat-icon>
              </a>
              &nbsp;&nbsp;
              <a href="javascript:void(0)" (click)="linkPartnerAccess(result.accessUriGuid)" *ngIf="
                  result.id > 0 &&
                  result.accessUriGuid != null &&
                  result.accessUriGuid.length > 0
                " title="Open Partner Access URL for {{ result.partnerName }}" target="_blank" rel="noopener noreferrer">
                <mat-icon>link</mat-icon>
              </a>

              &nbsp;&nbsp;
              <a href="javascript:void(0)" (click)="openPartnerInfoDialog(result)" *ngIf="result" title="Show Partner Info for {{ result.partnerName }}">
                <mat-icon>feed</mat-icon>
              </a>
            </mat-cell>
          </ng-container>
        </mat-table>

        <mat-paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" #TablePartnersPaginator="matPaginator" showFirstLastButtons>
        </mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</section>